import { render, staticRenderFns } from "./vipPopup.vue?vue&type=template&id=187e8002&scoped=true"
import script from "./vipPopup.vue?vue&type=script&lang=js"
export * from "./vipPopup.vue?vue&type=script&lang=js"
import style0 from "./vipPopup.vue?vue&type=style&index=0&id=187e8002&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187e8002",
  null
  
)

export default component.exports